import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Alert,
} from "reactstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

import { changePasswordThunk, resetPasswordThunk } from "../../slices/thunks";
import { Eye, EyeOff } from "react-feather";

const ResetPasswordPage = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const userName = location.state?.username;

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Please enter new password"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords do not match")
        .required("Please confirm password"),
    }),
    onSubmit: async (values) => {
      const success = await dispatch(
        resetPasswordThunk({
          userName,
          password: values.password,
        })
      );

      if (success) {
        navigate("/login");
      }
    },
  });

  return (
    <div className="auth-page-content mt-lg-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={6}>
            <Card>
              <CardBody>
                <h5 className="text-center text-success mb-4">
                  Reset Password
                </h5>

                {!userName && (
                  <Alert color="danger">
                    Invalid access. Please retry forgot password.
                  </Alert>
                )}

                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                  }}
                >
                  {/* Username (Disabled) */}
                  <div className="mb-3">
                    <Label>Email</Label>
                    <Input value={userName || ""} disabled />
                  </div>

                  {/* New Password */}
                  <div className="mb-3 position-relative">
                    <Label>New Password</Label>
                    <Input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.password}
                      invalid={
                        validation.touched.password &&
                        validation.errors.password
                          ? true
                          : false
                      }
                    />

                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "38px",
                        cursor: "pointer",
                        color: "#6c757d",
                      }}
                    >
                      {showPassword ? <EyeOff size={15} /> : <Eye size={15} />}
                    </span>

                    <FormFeedback>{validation.errors.password}</FormFeedback>
                  </div>

                  {/* Confirm Password */}
                  <div className="mb-4 position-relative">
                    <Label>Confirm Password</Label>
                    <Input
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.confirmPassword}
                      invalid={
                        validation.touched.confirmPassword &&
                        validation.errors.confirmPassword
                          ? true
                          : false
                      }
                    />

                    <span
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "38px",
                        cursor: "pointer",
                        color: "#6c757d",
                      }}
                    >
                      {showConfirmPassword ? (
                        <EyeOff size={15} />
                      ) : (
                        <Eye size={15} />
                      )}
                    </span>

                    <FormFeedback>
                      {validation.errors.confirmPassword}
                    </FormFeedback>
                  </div>

                  <button className="btn btn-success w-100" type="submit">
                    Reset Password
                  </button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ResetPasswordPage;
